import React, { useState, useEffect } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// images
import tickIcon from "../../../images/icons/tick_icon.png";

// styles
import * as styles from "./MeetAiTwin.module.css";

const MeetAiTwinComponent = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <section className={styles.meetAiTwinWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.headerSection}>
              <h1 className={styles.mainTitle}>Meet your AI Digital Twin™</h1>
              <p className={styles.description}>
                The Digital Twin shows your metabolism in real-time using data
                from smart devices to help you make informed choices in your
                daily life.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 col-6 order-1 order-md-1">
            <div className={styles.leftContent}>
              <div>
                <div className={styles.featureIcon}>
                  <img src={tickIcon} alt="Check" />
                </div>
                <div className={styles.featureContent}>
                  <h3 className={styles.featureTitle}>Twin Application</h3>
                  <p className={styles.featureDescription}>
                    Track how your food and activity your body instantly
                  </p>
                </div>
              </div>
              <div>
                <div className={styles.featureIcon}>
                  <img src={tickIcon} alt="Check" />
                </div>
                <div className={styles.featureContent}>
                  <h3 className={styles.featureTitle}>
                    AI- Powered Health Coaching
                  </h3>
                  <p className={styles.featureDescription}>
                    Receive daily insights tailored to your metabolism
                  </p>
                </div>
              </div>
              <div>
                <div className={styles.featureIcon}>
                  <img src={tickIcon} alt="Check" />
                </div>
                <div className={styles.featureContent}>
                  <h3 className={styles.featureTitle}>
                    Easy Progress Tracking
                  </h3>
                  <p className={styles.featureDescription}>
                    Monitor health improvements and stay motivated over time
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-12 order-3 order-md-2">
            <div className={styles.mobileImageWrapper}>
              {isMobile ? (
                <StaticImage
                  src="../../../images/aboutProgram/mob-pic.png"
                  alt="Twin Health Mobile App"
                  placeholder="blurred"
                  quality={90}
                  className={styles.mobileImage}
                  loading="lazy"
                />
              ) : (
                <StaticImage
                  src="../../../images/aboutProgram/mobile-pic.png"
                  alt="Twin Health Mobile App"
                  placeholder="blurred"
                  quality={90}
                  className={styles.mobileImage}
                  loading="lazy"
                />
              )}
            </div>
          </div>
          <div className="col-md-4 col-6 order-2 order-md-3">
            <div className={styles.rightContent}>
              <div>
                <div className={styles.featureIcon}>
                  <img src={tickIcon} alt="Check" />
                </div>
                <div className={styles.featureContent}>
                  <h3 className={styles.featureTitle}>
                    Real-time Health Monitoring
                  </h3>
                  <p className={styles.featureDescription}>
                    Track blood sugar, heart rate, sleep, and other key metrics
                  </p>
                </div>
              </div>
              <div>
                <div className={styles.featureIcon}>
                  <img src={tickIcon} alt="Check" />
                </div>
                <div className={styles.featureContent}>
                  <h3 className={styles.featureTitle}>
                    Instant Access to Experts
                  </h3>
                  <p className={styles.featureDescription}>
                    Chat with doctors and health coaches anytime you need
                    support
                  </p>
                </div>
              </div>
              <div>
                <div className={styles.featureIcon}>
                  <img src={tickIcon} alt="Check" />
                </div>
                <div className={styles.featureContent}>
                  <h3 className={styles.featureTitle}>
                    Sync with your Health Devices
                  </h3>
                  <p className={styles.featureDescription}>
                    Sync with your Health Devices
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetAiTwinComponent;
